import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'

function Faq() {
  return (
    <>
      <Helmet>
        <title>Answers to Your Questions | Indian Armour FAQs   </title>
        <meta name="description" content="Find solutions and clarity in our Frequently Asked Questions (FAQs) section. Explore comprehensive answers to common queries about Indian Armour products, services, and policies." />
        <link rel="canonical" href="https://www.indianarmour.com/faq" />
      </Helmet>
      <section className="inner-banner d-flex align-items-center justify-content-center text-center " style={{ backgroundImage: 'url("/images/faq.jpg")' }}>
        <div className="inner-banner-content1">
          <div className="container">
            <h1 className="text-white fw-bolder">Frequently Asked Questions</h1>
          </div>
        </div>
      </section>
      <section className="breadcrumb-inner pt-3  pb-5">
        <div className="container">
          <nav >
            <ol className="breadcrumb mb-0 justify-content-start">
              <li className="breadcrumb-item"><Link to="/">Home</Link></li>
              <li className="breadcrumb-item active" aria-current="page">Frequently Asked Questions</li>
            </ol>
          </nav>
        </div>
      </section>
      <section className="faq py-5 right-black-bg">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <ul className="nav nav-pills " id="pills-tab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button className="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Order Status</button>
                </li>
                <li className="nav-item" role="presentation">
                  <button className="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Product Questions</button>
                </li>
                <li className="nav-item" role="presentation">
                  <button className="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Testing &amp; Technical Details</button>
                </li>
              </ul>
              <div className="tab-content" id="pills-tabContent">
                <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="accordion" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingOne">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                              Can I order products in bulk?
                            </button>
                          </h2>
                          <div id="collapseOne" className="accordion-collapse collapse " aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                              <p>Yes. Bulk orders are available for government agencies, defence organizations, distributors, and institutional buyers.</p>
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingTwo">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                              How can I request a quotation?
                            </button>
                          </h2>
                          <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                              <p>
                                You can submit an enquiry through the website or contact our sales team at  <Link href="sales@indianarmour.com">sales@indianarmour.com</Link> with your product requirements.</p>
                            </div>
                          </div>
                        </div>

                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingthree">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsethree" aria-expanded="false" aria-controls="collapsethree">
                              How long does production take?

                            </button>
                          </h2>
                          <div id="collapsethree" className="accordion-collapse collapse" aria-labelledby="headingthree" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                              <p>Lead times vary depending on product type, order quantity, and customization requirements.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingfour">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsefour" aria-expanded="false" aria-controls="collapsefour">
                              Do you supply government tenders?

                            </button>
                          </h2>
                          <div id="collapsefour" className="accordion-collapse collapse" aria-labelledby="headingfour" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                              <p>Yes. Indian Armour works with government agencies, defence organizations, and institutional procurement programs.
                              </p>
                            </div>
                          </div>
                        </div>


                      </div>
                    </div>

                  </div>
                </div>



                <div className="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="accordion" id="accordionExample1">
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingOne2">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne1" aria-expanded="true" aria-controls="collapseOne1">
                              What is a bullet-resistant vest?
                            </button>
                          </h2>
                          <div id="collapseOne1" className="accordion-collapse collapse " aria-labelledby="headingOne2" data-bs-parent="#accordionExample1">
                            <div className="accordion-body">
                              <p> A bullet-resistant vest is personal protective equipment designed to reduce the risk of injury from ballistic threats. Different protection levels are available depending on the intended application.

                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingTwo2">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo2" aria-expanded="false" aria-controls="collapseTwo2">
                              What's the difference between soft armour and hard armour plates?
                            </button>
                          </h2>
                          <div id="collapseTwo2" className="accordion-collapse collapse" aria-labelledby="headingTwo2" data-bs-parent="#accordionExample1">
                            <div className="accordion-body">
                              <p>
                                Soft armour primarily protects against handgun rounds, while hard armour plates are designed to stop higher-velocity rifle threats.

                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingthree3">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsethree3" aria-expanded="false" aria-controls="collapsethree3">
                              Can Indian Armour customize body armour?

                            </button>
                          </h2>
                          <div id="collapsethree3" className="accordion-collapse collapse" aria-labelledby="headingthree3" data-bs-parent="#accordionExample1">
                            <div className="accordion-body">
                              <p>Yes. Indian Armour offers customized ballistic solutions based on requirements, protection levels, sizes, colours, and operational needs.</p>
                            </div>
                          </div>
                        </div>


                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingfour2">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsethree4" aria-expanded="false" aria-controls="collapsethree4">
                              Can ballistic plates be used with plate carriers?
                            </button>
                          </h2>
                          <div id="collapsethree4" className="accordion-collapse collapse" aria-labelledby="headingfour2" data-bs-parent="#accordionExample1">
                            <div className="accordion-body">
                              <p>Yes. Hard armour plates are designed to fit compatible plate carriers and tactical vests for enhanced protection.</p>
                            </div>
                          </div>
                        </div>

                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingFive2">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsethree5" aria-expanded="false" aria-controls="collapsethree5">
                              Do you manufacture lightweight ballistic armour?

                            </button>
                          </h2>
                          <div id="collapsethree5" className="accordion-collapse collapse" aria-labelledby="headingFive2" data-bs-parent="#accordionExample1">
                            <div className="accordion-body">
                              <p>Yes. Indian Armour offers lightweight ballistic solutions that balance protection, comfort, and mobility.
                              </p>
                            </div>
                          </div>
                        </div>



                      </div>
                    </div>

                  </div>

                </div>


                <div className="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="accordion" id="accordionExample2">
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingOne3">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne1-1" aria-expanded="true" aria-controls="collapseOne1-1">
                              Are your products tested?
                            </button>
                          </h2>
                          <div id="collapseOne1-1" className="accordion-collapse collapse " aria-labelledby="headingOne3" data-bs-parent="#accordionExample2">
                            <div className="accordion-body">
                              <p> Yes, our products have been tested at international laboratories such as H.P. White’s Laboratory, Whitshire, and NIJ, and test records are available upon request. In addition, our company is also listed on the NIJ website. For further information, please visit <Link to="https://www.justnet.org/compliant/ballistic cpl.html.">https://www.justnet.org/compliant/ballistic cpl.html.</Link></p>
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingTwo3">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo2-2" aria-expanded="false" aria-controls="collapseTwo2-2">
                              What is NIJ?
                            </button>
                          </h2>
                          <div id="collapseTwo2-2" className="accordion-collapse collapse" aria-labelledby="headingTwo3" data-bs-parent="#accordionExample2">
                            <div className="accordion-body">
                              <p>
                                There are various ballistics protection level standards. The US National Institute of Justice (NIJ) is the most widely accepted standard for body armour. This is widely regarded as the industry standard for testing body armour. The NIJ guidelines specify the threats that each level of body armour will shield against, as well as the power of the assault that it will withstand.</p>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Faq